import DealerAccountRequestFormState from "@aus/Store/Components/DealerAccountRequestForm/DealerAccountRequestFormState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: DealerAccountRequestFormState = {
    fieldValues: {},
};

const reducer = {
    "Components/DealerAccountRequestForm/ClearForm": (draft: Draft<DealerAccountRequestFormState>) => {
        draft.fieldValues = {};
    },
    "Components/DealerAccountRequestForm/SetFieldValue": (
        draft: Draft<DealerAccountRequestFormState>,
        action: { key: string; value: string },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
